(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartPage extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.totalEl = this.querySelector('[data-cart-total]');
      this.lines = Array.from(this.querySelectorAll('.cart-page__line'));

      const fallbackFormat = '$' + '{' + '{amount}}';
      const bootstrap = this.querySelector('[data-cart-bootstrap]');
      try {
        const data = bootstrap ? JSON.parse(bootstrap.textContent) : {};
        this.moneyFormat = data.moneyFormat || fallbackFormat;
      } catch (err) {
        this.moneyFormat = fallbackFormat;
      }

      this.lines.forEach((line) => this.bindLine(line));
    }

    bindLine(line) {
      const input = line.querySelector('[data-qty-input]');
      const decBtn = line.querySelector('[data-qty-delta="-1"]');
      const incBtn = line.querySelector('[data-qty-delta="1"]');
      const removeLink = line.querySelector('[data-remove]');

      if (input) {
        input.dataset.lastValue = input.value;
        input.addEventListener('change', () => this.changeQty(line, parseInt(input.value, 10)));
      }

      if (decBtn) {
        decBtn.addEventListener('click', () => {
          const next = Math.max(0, parseInt(input.value, 10) - 1);
          this.changeQty(line, next);
        });
      }

      if (incBtn) {
        incBtn.addEventListener('click', () => {
          const next = parseInt(input.value, 10) + 1;
          this.changeQty(line, next);
        });
      }

      if (removeLink) {
        removeLink.addEventListener('click', (event) => {
          event.preventDefault();
          this.changeQty(line, 0);
        });
      }
    }

    async changeQty(line, quantity) {
      const key = line.dataset.key;
      if (!key || Number.isNaN(quantity)) return;

      const input = line.querySelector('[data-qty-input]');
      const previous = input ? parseInt(input.dataset.lastValue, 10) : null;

      line.dataset.loading = 'true';

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: key, quantity: quantity }),
        });

        if (!response.ok) throw new Error('Cart change failed: ' + response.status);
        const cart = await response.json();
        this.applyCart(line, cart, quantity);
      } catch (err) {
        console.warn('[cart-page] update failed', err);
        if (input && previous != null) input.value = previous;
        line.dataset.loading = 'false';
      }
    }

    applyCart(line, cart, requestedQty) {
      if (requestedQty === 0) {
        line.dataset.removing = 'true';
        setTimeout(() => {
          line.remove();
          this.afterApply(cart);
        }, 200);
        return;
      }

      const input = line.querySelector('[data-qty-input]');
      const item = cart.items.find((it) => it.key === line.dataset.key);

      if (item) {
        if (input) {
          input.value = item.quantity;
          input.dataset.lastValue = String(item.quantity);
        }
        const lineTotal = line.querySelector('[data-line-total]');
        if (lineTotal) lineTotal.textContent = this.formatMoney(item.final_line_price);
      }

      line.dataset.loading = 'false';
      this.afterApply(cart);
    }

    afterApply(cart) {
      if (this.totalEl) this.totalEl.textContent = this.formatMoney(cart.total_price);

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

      if (cart.item_count === 0) {
        window.location.reload();
      }
    }

    formatMoney(cents) {
      const value = (cents / 100).toFixed(2);
      const [whole, decimal] = value.split('.');
      const withSeparators = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const formatted = withSeparators + '.' + decimal;
      return this.moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, formatted)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + decimal)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
    }
  }

  if (!customElements.get('cart-page')) {
    customElements.define('cart-page', CartPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionInfiniteScroll extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.grid = this.querySelector('[data-products-grid]');
      this.sentinel = this.querySelector('[data-sentinel]');
      this.loading = false;

      if (!this.grid || !this.sentinel || !this.sentinel.dataset.nextUrl) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) this.loadNext();
        },
        { rootMargin: '400px 0px' }
      );
      this.observer.observe(this.sentinel);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    async loadNext() {
      const nextUrl = this.sentinel.dataset.nextUrl;
      if (this.loading || !nextUrl) return;
      this.loading = true;

      try {
        const url = new URL(nextUrl, window.location.origin);
        url.searchParams.set('section_id', this.sectionId);

        const response = await fetch(url.toString());
        if (!response.ok) throw new Error('Section fetch failed: ' + response.status);

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newCards = doc.querySelectorAll('[data-products-grid] > [data-product-card]');
        const fragment = document.createDocumentFragment();
        newCards.forEach((card) => fragment.appendChild(card));
        this.grid.appendChild(fragment);

        const newSentinel = doc.querySelector('[data-sentinel]');
        const newNextUrl = newSentinel ? newSentinel.dataset.nextUrl : null;
        if (newNextUrl) {
          this.sentinel.dataset.nextUrl = newNextUrl;
        } else {
          delete this.sentinel.dataset.nextUrl;
          this.observer.disconnect();
        }
      } catch (err) {
        console.error('[collection-infinite-scroll]', err);
      } finally {
        this.loading = false;
      }
    }
  }

  if (!customElements.get('collection-infinite-scroll')) {
    customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    connectedCallback() {
      const select = this.querySelector('select');
      if (!select) return;
      select.addEventListener('change', () => {
        select.form.submit();
      });
    }
  }
  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductDetail extends HTMLElement {
    connectedCallback() {
      this.variantInput = this.querySelector('[data-variant-id]');
      this.priceEls = this.querySelectorAll('[data-price]');
      this.pills = this.querySelectorAll('[data-size-pill]');

      const dataNode = this.querySelector('[data-variants]');
      try {
        this.variants = dataNode ? JSON.parse(dataNode.textContent) : [];
      } catch (err) {
        this.variants = [];
      }

      this.pills.forEach((pill) => {
        if (pill.disabled) return;
        pill.addEventListener('click', () => this.select(pill.dataset.variantId));
      });

      if (this.variantInput && this.variantInput.value) {
        this.select(this.variantInput.value);
      }
    }

    select(variantId) {
      if (!variantId) return;
      const id = String(variantId);

      if (this.variantInput) this.variantInput.value = id;

      this.pills.forEach((p) => {
        p.setAttribute('aria-pressed', p.dataset.variantId === id ? 'true' : 'false');
      });

      const variant = this.variants.find((v) => String(v.id) === id);
      if (variant && variant.priceFormatted) {
        const html = variant.compareAtPriceFormatted
          ? `<s class="product-detail__price-compare">${variant.compareAtPriceFormatted}</s> <span class="product-detail__price-sale">${variant.priceFormatted}</span>`
          : variant.priceFormatted;
        this.priceEls.forEach((el) => {
          el.innerHTML = html;
        });
      }
    }
  }

  if (!customElements.get('product-detail')) {
    customElements.define('product-detail', ProductDetail);
  }

  } catch(e) { console.error(e); }
})();
})();
